import styled from 'styled-components';
import Button from 'components/ui/Button';
import Link from 'components/ui/Link';

export default styled.form`
  display: flex;
  flex-direction: column;
  ${Button} {
    margin-top: 1em;
    background: #fff;
    border-radius: 11px;
    border: 2px solid #585551;
  }

  ${Link} {
    align-self: center;
    margin-top: 1rem;
    font-size: 15px;
    color: #47b5be;
  }
  * + .uk-margin {
    margin-top: 0px !important;
  }
`;
